import { datadogLogs } from '@datadog/browser-logs';
import type { GreenroomUser } from '../stores/types/session';

if (process.env.REACT_APP_NODE_ENV) {
	datadogLogs.init({
		clientToken: 'pubec37005c41fa3dc2ff149c3743b05b6d',
		forwardErrorsToLogs: true,
		sampleRate: 100,
		env: process.env.REACT_APP_NODE_ENV,
		// version: process.env.REACT_APP_NODE_ENV,
		service: `gr-${process.env.REACT_APP_NODE_ENV}-client`,
		forwardConsoleLogs: ['error', 'warn', 'info'],
		// proxyUrl: `${process.env.REACT_APP_API_HOST}/v2/greenroom/dd-proxy`,
	});
}

datadogLogs.logger.setLevel(process.env.REACT_APP_NODE_ENV ? 'info' : 'debug');

datadogLogs.logger.setHandler(process.env.REACT_APP_NODE_ENV ? 'http' : 'console');

export function setLogUser(user: GreenroomUser | null): void {
	if (!user || !process.env.REACT_APP_NODE_ENV) {
		return;
	}

	const name = `${user?.first_name ?? ''} ${user?.last_name ?? ''}`;
	const id = user?.gr_user?.toString() ?? '';
	const email = user?.email ?? '';
	datadogLogs.setUser({ id, email, name });
}

export function setLogMeetingId(meetingId: string | undefined | null): void {
	if (!process.env.REACT_APP_NODE_ENV) {
		return;
	}
	if (meetingId) {
		datadogLogs.setGlobalContextProperty('meeting_id', meetingId);
	} else {
		datadogLogs.removeGlobalContextProperty('meeting_id');
	}
}

export const appLogger = datadogLogs.logger;
